<script setup lang="ts">
  import { TableLoadingProps } from '@/shared/lib';

  const props = defineProps<TableLoadingProps>();
</script>
<template>
  <div
    class="w-full p-4 space-y-6 divide-y divide-gray-200 rounded-sm animate-pulse md:p-6"
  >
    <div
      v-for="index in props.rowSize ?? 11"
      :key="index"
      class="flex items-center justify-between"
      :class="{ 'pt-4': index === 1 }"
    >
      <div class="flex w-full justify-between">
        <div
          v-for="index in props.columnSize ?? 5"
          :key="index"
          class="h-3.5 bg-gray-300 rounded-full w-24 mt-2.5 mb-2.5"
        />
      </div>
    </div>
  </div>
</template>
